import React from 'react';
import { rcsImageSizes, rcsSizeLabel, rcsImageSizeLimitLabel } from "../../../../util/rcsTypeUtil";
import Modal from "../../../../component/modal/ModalTemplate";
import * as apiUtil from '../../../../util/apiUtil';
import button from "bootstrap/js/src/button";
import Loading from "../../../../component/loading/Loading";
import ImageSelectModal from "../../../../component/modal/ImageSelectModal";
import ImageAddModal from "../../../selfmessage/image/component/ImageAddModal";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as selfAction from "../../../selfmessage/message/store/selfmessage";
import UpdateImageSuccessModal from "./UpdateImageSuccessModal";

class UpdateImageModal extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.ajaxGetMsInfo = this.ajaxGetMsInfo.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);

        this.openImageListModal = this.openImageListModal.bind(this);
        this.closeImageListModal = this.closeImageListModal.bind(this);
        this.handleImageUploadModal = this.handleImageUploadModal.bind(this);
        this.checkFileName = this.checkFileName.bind(this);
        this.changePreview = this.changePreview.bind(this);
        this.handleImageUploaded = this.handleImageUploaded.bind(this);

        this.handleCPInput = this.handleCPInput.bind(this);
        this.handleRCSFile = this.handleRCSFile.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.ajaxUpdateImage = this.ajaxUpdateImage.bind(this);

        this.handleSelectImage = this.handleSelectImage.bind(this);
        this.closeSuccessModal = this.closeSuccessModal.bind(this);
        this.openSuccessModal = this.openSuccessModal.bind(this);
        this.setIsAIImage = this.setIsAIImage.bind(this);

        this.state={
            loading: false,
            successModal: false,
            messageType: '',
            preview1: '',
            preview2: '',

            selectedImage: null, // 선택한 이미지 객체
            selectedFile: null,  // 새로 업로드할 파일
            newImageName: '',    // 새로 업로드할 이미지 이름

            RCS: [],
            MMS: {},
            index: 0,

            imageListModal: false,
            imageUploadModal: false,

            imageList: [],
            page: 1,
            size: 10,
            sort: 'date',
            total: 0,
            isAIImage: false,
        }
    }// end constructor

    // 선택 이미지 받기
    handleSelectImage(image) {
        this.setState({ selectedImage: image, selectedFile: null, newImageName: '' });
    }

    setIsAIImage(isChecked) {
        this.setState({ isAIImage: isChecked });
    }

    /*input 관리*/
    async handleRCSFile(file) {
        const { SelfAction, selectedSlide } = this.props;
        await SelfAction.setRCSFile(selectedSlide-1, file);
        await SelfAction.setMMSFile(file);
    }// end handleMainFile

    handleFileChange(file) {
        if (!file) return;
        const objectUrl = URL.createObjectURL(file);
        this.setState({
            selectedFile: file,
            preview1: objectUrl,
            selectedImage: null
        });
    }

    async handleCPInput(id, value) {
        const { SelfAction, RCSInfo, RCSFile, imgName } = this.props;

        switch(id) {
            case "imgFile":
                await this.handleFileChange(value);
                break;
            case "imgName":
                SelfAction.setImgName(value);
                break;
            default:
                break;
        }// end switch
    }// end handleSendDate

    // 2026-03-18 fix: {…this.state} 스프레드 제거 - Safari 무한 로딩 버그 수정
    changePreview(url) {
        this.setState({ preview1: url });
    }

    handlePageChange (value) {
        this.setState({ page: value }, () => this.ajaxGetImageList());
    }

    componentDidMount() {
        this.ajaxGetMsInfo();
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    closeImageListModal(){ this.setState({ imageListModal: false }) }
    openImageListModal(){ this.setState({ imageListModal: true }, () => this.ajaxGetImageList()) }

    handleImageUploadModal() {
        const { imageUploadModal } = this.state;
        this.setState({ imageUploadModal: !imageUploadModal })
    }

    handleImageUploaded(file) {
        this.setState({
            newImageFile: file
        });
    }

    checkFileName() {
        const { imgName } = this.props;
        if (! imgName) {
            alert('이미지명이 입력되지 않았습니다.');
            return false;
        }

        this.handleImageUploadModal();

        return true;
    }

    openSuccessModal(){ this.setState({ successModal: true })}

    closeSuccessModal(){
        const { cmpnUid } = this.props;
        this.setState({ successModal: false });
        window.location.href = `/sent/detail/${cmpnUid}`;
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.isOpen !== nextProps.isOpen
            || this.props.onClose !== nextProps.onClose
            || this.state.preview1 !== nextState.preview1
            || this.state.preview2 !== nextState.preview2
            || this.state.imageList !== nextState.imageList
            || this.state.imageUploadModal !== nextState.imageUploadModal
            || this.state.imageListModal !== nextState.imageListModal
            || this.state.messageType !== nextState.messageType
            || this.state.page !== nextState.page
            || this.state.size !== nextState.size
            || this.state.total !== nextState.total
            || this.state.loading !== nextState.loading
            || this.state.RCS !== nextState.RCS
            || this.state.MMS !== nextState.MMS
            || this.state.sort !== nextState.sort
            || this.props.MMSFile !== nextProps.MMSFile
            || this.props.RCSFile !== nextProps.RCSFile
            || this.props.imgName !== nextProps.imgName
            || this.props.RCSInfo !== nextProps.RCSInfo
            || this.state.successModal !== nextState.successModal
            || this.state.isAIImage !== nextState.isAIImage
        )
    }

    clearFileInput() {
        // this.fileInputRef.current.value = '';
    }// end clearfileinput

    ajaxGetImageList(){
        const { page, size, sort } = this.state;
        const requestType = this.props.rcsType ?? 0;
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/image/list",
            method: apiUtil.requestMethod.POST,
            data: {
                imgType: "RCS",
                sizes: rcsImageSizes(this.props.rcsType ?? 0),
                rcsType: Number(this.props.rcsType ?? 0),
                sort: sort,
                page: page,
                size: size,
            },
            success: async (result) => {
                if ((this.props.rcsType ?? 0) !== requestType || this.state.page !== page) return;
                await this.setState({ imageList: result.content, total: result.total });
            }
        })
    }// end ajaxGetImageList

    ajaxUpdateImage() {
        const { cmpnUid, imgName } = this.props;

        const { selectedImage, selectedFile, isAIImage } = this.state;

        let data = new FormData();
        // rcsType으로 이미지인지 텍스트인지 확인

        const selfUpdateImageRequest = selectedImage
            ? {
                imgName: selectedImage.imgName,
                selectImage: selectedImage.uid,
                originId: selectedImage.imgId,
                isAIImage: isAIImage,
            }
            : {
                imgName: imgName,
                selectImage: '',
                originId: '',
                isAIImage: isAIImage,
            };

        data.append('selfUpdateImageRequest', JSON.stringify(selfUpdateImageRequest));


        if (selectedFile) data.append('RCSFile', selectedFile);

        /*데이터 전송*/
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: `/api/bizchat/message/update/${cmpnUid}/image`,
            method: apiUtil.requestMethod.POST,
            data: data,
            isFile: true,
            success: async (result) => {
                if (result === 'Success') {
                    this.openSuccessModal();
                }
            }
        })
    }

    ajaxGetMsInfo() {
        const { cmpnUid } = this.props;
        const { preview2 } = this.state;
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: `/api/bizchat/message/info/${cmpnUid}`,
            method: apiUtil.requestMethod.POST,
            success: async (result) => {
                result.rcs.map((rcs, index) => {
                    if(rcs.imgOrigId){
                        this.setState({preview1: rcs.imgOrigId });
                        this.setState({preview2: rcs.imgOrigId});
                    }
                    this.setState({index: index})
                });
                /*초기 버전, MMS 는 등록되지 않기 때문에 file 이 따로 존재 X*/
                if(result.mms.fileInfo){
                    this.setState({ preview2: result.mms.fileInfo });
                }
                await this.setState({RCS: result.rcs, MMS: result.mms});

            }
        })
    }// end ajax
    render() {
        const { loading, index } = this.state;

        const { isOpen, onClose } = this.props;

        const { SelfAction, imgName, cmpnUid } = this.props;
        const {  imageListModal, imageUploadModal, imageList, total, size, successModal } = this.state;

        const { openImageListModal, closeImageListModal, handleImageUploadModal, handlePageChange, handleCPInput, ajaxUpdateImage, closeSuccessModal } = this;
        const { checkFileName, setIsAIImage } = this;

        const { preview1, preview2, selectedImage, isAIImage } = this.state;
        return(
            <Modal
                open={isOpen}
                handleClose={onClose}
                modalTitle={"이미지 수정하기"}
                className={"react-modal"}
            >
                <Loading loading={loading}/>
                <div className="modal-body">
                    <div className="d-flex justify-content-center mb-3">
                        <img src={preview1} alt="이미지"/>
                    </div>
                    <div className='file-upload-area' style={{ textAlign: 'center' }}>
                        <div className="input-group" style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem' }}>
                            <button
                                className="btn btn-sm btn-primary rounded d-flex align-items-center me-2"
                                onClick={openImageListModal}
                            >
                                <span className="material-symbols-rounded fs-5 me-2">photo_library</span>불러오기
                            </button>
                            <button
                                className="btn btn-sm btn-primary rounded d-flex align-items-center"
                                onClick={handleImageUploadModal}
                            >
                                <span className="material-symbols-rounded fs-5 me-2">upload_file</span>업로드
                            </button>
                        </div>
                        <p className='fs-6 fw-normal text-muted'>파일유형 : <strong>jpg/jpeg</strong> | {rcsSizeLabel(this.props.rcsType ?? 0)}px ({rcsImageSizeLimitLabel(this.props.rcsType ?? 0)})</p>
                    </div>
                    <div className='row pe-0'>
                        <div className='pe-0 pb-3 pt-2'>
                        <span className="fs-7 text-muted">
                            * AI 기본법에 따라 AI로 생성한 이미지는 반드시 체크해 주세요. 체크 시 메시지에 AI 생성 이미지 안내 문구가 자동으로 포함됩니다.
                        </span>
                            <div className="form-check mt-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="isAIImage"
                                    checked={isAIImage}
                                    onChange={(e) => setIsAIImage(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="isAIImage">
                                    AI 생성 이미지 여부
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"modal-footer justify-content-center"}>
                    <button className={"btn btn-primary btn-md"} onClick={ajaxUpdateImage}>수정하기</button>
                </div>
                <ImageSelectModal
                    handleChangePage={handlePageChange}
                    page={this.state.page}
                    clearFile={()=>{
                        SelfAction.setRCSFile(index, null);

                        SelfAction.setMMSFile(null);
                        this.clearFileInput();
                    }}
                    changePreview={(imageUrl, imageObj) => {
                        this.setState({ preview1: imageUrl, selectedImage: imageObj })
                    }}
                    SelfAction={SelfAction}
                    isOpen={imageListModal}
                    isClose={closeImageListModal}
                    MTYPE={"RCS"}
                    choiceCallback={(image) => this.handleSelectImage(image)}
                    imageList={imageList}
                    total={total}
                    size={size}
                    index={index}
                />
                <ImageAddModal
                    rcsType={this.props.rcsType ?? 0}
                    isOpen={imageUploadModal}
                    handleClose={handleImageUploadModal}
                    setValue={handleCPInput}
                    imgUploadAction={checkFileName}
                    imgType="RCS"
                    imgName={imgName}
                />
                <UpdateImageSuccessModal
                    open={successModal}
                    isClose={closeSuccessModal}
                    cmpnUid={cmpnUid}
                />
            </Modal>

        )
    }// end render
}// end class

export default connect(
    (state) => ({
        RCSFile: state.selfmessage.RCSFile,
        MMSFile: state.selfmessage.MMSFile,
        imgName: state.selfmessage.imgName,
        files: state.selfmessage.files,
        RCSInfo: state.selfmessage.RCSInfo,
    }),
    (dispatch) => ({
        SelfAction: bindActionCreators(selfAction, dispatch)
    })
) (UpdateImageModal);
